<template>
  <div class="appointment">
    <div class="banner">
      <img src="@/assets/index/convenienceServe/appointment/dp-sy-bm11.png" alt />
    </div>
    <div class="textarea">
      <textarea placeholder="请输入办理事项描述......" v-model="content"></textarea>
    </div>
    <div class="choose">
      <p>{{option}}</p>
    </div>

    <p class="name">姓名: {{name}}</p>
    <p class="phone">电话: {{phone}}</p>
    <p class="leave-time">留言时间: {{time}}</p>
    <div class="submit">
      <button @click="submit">确认提交</button>
    </div>

    <div class="motai" v-if="motaiShow">
      <div class="msg">
        <p>填写办理事项成功</p>
        <p>管理员将于2个工作日内审核并回复办理进度，敬请期待</p>
        <button @click="motai">我知道了</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      option: "事项类型：惠农政策",
      name: "",
      phone: sessionStorage.getItem('mobileid'),
      time: "",
      content: "", //提交的内容,
      motaiShow: false
    };
  },
  created: function() {
    this.option = "事项类型：" + this.$route.query.value;
    let date = new Date();
    this.time =
      date.getFullYear() +
      "." +
      (date.getMonth() + 1) +
      "." +
      date.getDate() +
      " " +
      date.getHours() +
      ":" +
      date.getMinutes();
    this.name = sessionStorage.getItem("name");
  },
  methods: {
    motai() {
      this.motaiShow = !this.motaiShow;
      this.$router.go(-1)
    },
    submit() {
      if (this.content != "") {
        this.axios
          .post("/api/Main/AddService", {
            headline: this.$route.query.value,
            name: sessionStorage.getItem("name"),
            phone: sessionStorage.getItem("phone"),
            memo: this.content,
            createtime: this.time,
            post: sessionStorage.getItem("token")
          })
          .then(e => {
            // console.log(e.data);
            switch (e.data.code) {
              case 0:
                this.motaiShow = true
                break;

              default:
                alert(e.data.msg)
                break;
            }
          })
          .catch(err => {
            console.log(err);
          });
      }else{
        alert('留言栏不能为空')
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.appointment {
  .motai {
    .msg {
      p {
        position: absolute;
        text-align: center;

        &:nth-child(1) {
          font-size: 0.32rem;
          font-weight: bold;
          bottom: 2rem;
          left: 20%;
        }
        &:nth-child(2) {
          font-size: 0.28rem;
          color: #999999;
          bottom: 1rem;
        }
      }
      button {
        position: absolute;
        border: 0;
        border-radius: 0.34rem;
        background-image: linear-gradient(1deg, #f9b94d 0%, #fdcb76 100%),
          linear-gradient(#eb7d14, #eb7d14);
        color: #fff;
        width: 2.35rem;
        height: 0.68rem;
        bottom: 0.2rem;
        font-size: .26rem;
        left: 20%;
      }
      background: url(../../../../assets/index/convenienceServe/appointment/dp-sy-bm9.png)
        center no-repeat;
      background-size: 100% 100%;
      width: 4.4rem;
      height: 5.5rem;
      margin: 20vh auto;
      position: relative;
    }
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    background: rgba($color: #000000, $alpha: 0.2);
  }

  .submit {
    button {
      width: 3.8rem;
      height: 0.8rem;
      background-image: linear-gradient(1deg, #f9b94d 0%, #fdcb76 100%),
        linear-gradient(-70deg, #fb3f3f 0%, #fe5f5f 100%);
      background-blend-mode: normal, normal;
      box-shadow: 0.01rem 0.1rem 0.1rem 0px rgba(249, 186, 79, 0.1);
      border-radius: 0.08rem;
      border: 0;
      color: #fff;
      font-size: 0.3rem;
    }
    text-align: center;
    padding: 0.4rem 0 0.8rem 0;
  }

  .name,
  .phone,
  .leave-time {
    font-size: 0.3rem;
    width: 94%;
    margin: 0 auto;
    color: #999999;
    line-height: 3;
    border-bottom: 0.01rem solid #e6e6e6;
  }

  .choose {
    width: 94%;
    margin: 0.3rem auto 0.3rem auto;
    font-size: 0.3rem;
    color: #999999;
  }

  .textarea {
    textarea {
      background: #f9f9f9;
      width: 94%;
      margin: 0 auto;
      font-size: 0.32rem;
      padding: 0.2rem;
      border-radius: 0.08rem;
      height: 4.8rem;
      border: none;
    }
    line-height: 0;
    text-align: center;
  }
  .banner {
    img {
      width: 70%;
    }
    width: 94%;
    margin: 0 auto;
    padding-top: 0.5rem;
    line-height: 0;
  }
  padding-top: 1rem;
  background: #fff;
  min-height: 100vh;
}
</style>



